import Vue from "vue";
import VueRouter from 'vue-router'

Vue.use(VueRouter);

import Map from './MapComponent/MapComponent';
import Catalogue from './Catalouge/Catalogue';
import FilterComponent from './Filter/FilterComponent/FilterComponent';

// Pagination Component
import Paginate from 'vuejs-paginate';

// Vue Moment
import moment from 'moment';

const lang = $('body').data().locale;
const enPrefix = lang === 'en' ? '/en' : '';
moment.locale(lang);
Vue.use(require('vue-moment'), {moment});

// ** Pagination Dependency ** /
Vue.component('paginate', Paginate);

const routes = [
  {path: enPrefix + '/properties', component: Map},
  {path: enPrefix + '/properties/catalogue', component: Catalogue}
];

const router = new VueRouter({
  routes,
  hash: false,
  mode: 'history',
});

export const bus = new Vue();
const FilterComponents = new Vue({
  el: '#FilterComponents',
  data: {
    formInputs: {
      type: Array,
    },
    formData: '',
    offersData: '',
    authHandler: '',
    lang: jsLangs,
  },
  router,
  components: {
    FilterComponent
  },
  methods: {},
  mounted: function () {
    // Preloader
    (function () {
      const loader = $("#preLoader");
      setTimeout(() => {
        loader.fadeOut("slow");
      }, 1200);
    })();

    moment.locale(lang);
  }
});
